// @ts-check
import { Image, View } from '@react-pdf/renderer';
import React from 'react';

// This allows developers to trace over a customer's design.
// https://github.com/diegomura/react-pdf/issues/218
export default function Stencil({ src, debug = false, style }) {
  if (!src) return null;
  return (
    <View
      fixed
      style={[
        {
          position: 'absolute',
          opacity: 0.5,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: '100%',
        },
        style,
      ]}
      debug={debug}
    >
      <Image src={src} style={{ height: '100%' }} />
    </View>
  );
}
